import { ChangeDetectorRef, Component, Input, OnInit, ViewRef } from '@angular/core';
import { Link } from '../../../../../models/link';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { AssetService } from '../../../../../services/asset.service';
import { LinkService } from '../../../../../services/link.service';
import { ModalService } from '../../../../../services/modal.service';
import { UrlWhitelist } from '../../../../../../environments/configs/url-whitelist';
import { Digi4SchoolValidationDirective } from '../../../../../directives/digi4-school-validation.directive';

@Component({
    selector: 'app-page-link',
    templateUrl: './page-link.component.html',
    styleUrls: ['./page-link.component.scss'],
    standalone: true,
    imports: [
        Digi4SchoolValidationDirective
    ]
})
export class PageLinkComponent implements OnInit {

    @Input() link: Link;
    imageUrl: string;
    isOnWhiteList: boolean;

    shouldOpenInModal: boolean;

    constructor(private applicationStateService: ApplicationStateService,
                private linkService: LinkService,
                private modalService: ModalService,
                private assetService: AssetService,
                private changeDetectorRef: ChangeDetectorRef) {

        this.changeDetectorRef.detach();
    }

    ngOnInit(): void {
        this.isOnWhiteList = UrlWhitelist.isOnWhiteList(this.link);
        this.shouldOpenInModal = !this.isOnWhiteList || this.link.overlay || !this.link.bypassCheck;

        switch (this.link.type) {
            case 5:
                if (this.link.isSolutionLink) {
                    this.link.zIndex += 1;
                }

                if (this.link.isSolutionLink && this.applicationStateService.bookConfig.displaySolutions) {
                    this.imageUrl = this.assetService.getUrl('solution-icon.png');
                } else {
                    this.link.position.h += 1.5;
                }

                break;
            case 3:
                this.imageUrl = this.assetService.getUrl('link-modal/large-link-icon-video.png');
                break;
            case 2:
                this.imageUrl = this.assetService.getUrl('link-modal/large-link-icon-photo.png');
                break;
            default:
                this.imageUrl = this.assetService.getUrl('link-modal/large-link-icon-weblink.png');
        }
        this.detectChanges();
    }

    onLinkClick(): void {
        this.linkService.logUsage(this.link);
    }

    onTap(): void {
        this.link.wasClicked = true;
        this.modalService.openModal(this.link);
        this.detectChanges();
    }

    private detectChanges(): void {
        if (!(this.changeDetectorRef as ViewRef).destroyed) {
            this.changeDetectorRef.reattach();
            this.changeDetectorRef.detectChanges();
        }
    }
}
